<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: '서울시 마포구 월드컵로16길 52-12<br>동양노블레스 202호 (03997)',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: 'Tel : 070 8270 9380<br>Mobile : 010 3730 9380',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'jh.yoon@lithos.kr<br>information@lithos.kr',
        },
      ],
    }),
  }
</script>
